import type { AxiosInstance, InternalAxiosRequestConfig } from 'axios';

const MUTATING_METHODS = new Set(['post', 'put', 'delete', 'patch']);

/**
 * Installs a request interceptor that attaches a fresh `Dcl-CorrelationId`
 * header (RFC 4122 v4 UUID) to every POST, PUT, DELETE and PATCH request.
 *
 * Returns an unregister function — useful for tests.
 */
export function installCorrelationIdInterceptor(axiosInstance: AxiosInstance): () => void {
  const id = axiosInstance.interceptors.request.use(
    (config: InternalAxiosRequestConfig): InternalAxiosRequestConfig => {
      if (MUTATING_METHODS.has((config.method ?? '').toLowerCase())) {
        config.headers.set('Dcl-CorrelationId', crypto.randomUUID());
      }
      return config;
    },
  );

  return () => axiosInstance.interceptors.request.eject(id);
}
